import {
  dropdown,
  multi,
  number,
  OTHER,
  option,
  single,
  text,
  type UsFieldDef,
} from "../us-fields";

export const KIDNEY_FINDINGS: readonly UsFieldDef[] = [
  single(
    "renal.hydronephrosis",
    "Hydronephrosis",
    [
      option("absent", "Absent"),
      option("mild", "Mild"),
      option("moderate", "Moderate"),
      option("severe", "Severe"),
    ],
    { normal: "absent" },
  ),
  single(
    "renal.ureteral_calculus",
    "Ureteral calculus",
    [
      option("absent", "Absent"),
      option("present", "Present", {
        reveals: [
          dropdown("renal.calculus_location", "Calculus location", [
            option("not_applicable", "N/A"),
            option("uvj", "UVJ"),
            option("ureter", "Ureter"),
            option("upj", "UPJ"),
            option("kidney", "Kidney"),
          ]),
          number("renal.calculus_size", "Calculus size", "mm"),
        ],
      }),
    ],
    { normal: "absent" },
  ),
  text("renal.other_findings", "Other kidney findings"),
];

const SIDED_PRESENCE = [
  option("none", "None"),
  option("right", "Right"),
  option("left", "Left"),
  option("bilateral", "Bilateral"),
];

export const RENAL_IMPRESSION: readonly UsFieldDef[] = [
  single("renal.impression_hydronephrosis", "Hydronephrosis", SIDED_PRESENCE, {
    normal: "none",
  }),
  single(
    "renal.impression_nephrolithiasis",
    "Nephrolithiasis",
    SIDED_PRESENCE,
    { normal: "none" },
  ),
  single(
    "renal.impression_urinary_retention",
    "Urinary retention",
    [option("no", "No"), option("yes", "Yes")],
    { normal: "no" },
  ),
  multi(
    "renal.impression",
    "Impression",
    [option("indeterminate", "Indeterminate"), OTHER],
    { optional: true },
  ),
];
